import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormControl, ValidationErrors, Validators} from "@angular/forms";
import {formatDate} from "@angular/common";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {AlertService} from "../../services/alert/alert.service";
import {IonInput, Platform, PopoverController} from "@ionic/angular";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {AuthService} from "../../services/mygreencountry/auth.service";
import {IntlTelInputComponent} from "intl-tel-input-ng";
import {
    AGE_MIN_LIMIT,
    BEFORE_SCHOOL_CHILD_CLASS,
    FIRST_DAY_OF_MONTH,
    GENDER_FEMALE,
    GENDER_MALE, LANGUAGES,
    LAST_DAT_OF_MONTH,
    MONTH_NAMES,
    SCHOOL_CLASS,
    YEAR_START
} from "../../shared/constants";
import {cyrillicCharactersValidator} from "../../shared/validation-rules/rules";
import {BehaviorSubject, Observable} from "rxjs";
import {RegisterApiResponse} from "../../types/apiResponse.interface";
import {AnalyticsService} from "../../services/mygreencountry/analytics.service";
import {PopoverComponent} from "../../shared/components/popover/popover.component";
import {CookieService} from "ngx-cookie-service";
import {TranslocoService} from "@jsverse/transloco";
import {LocaleService} from "../../services/mygreencountry/locale.service";
import {Title} from "@angular/platform-browser";
import {PhoneUtilsService} from "../../services/phone-utils/phone-utils.service";
import {GoogleAnalyticsService} from "../../services/google-analytics/google-analytics.service";


@Component({
    selector: 'app-registration',
    templateUrl: './registration.page.html',
    styleUrls: ['./registration.page.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RegistrationPage implements OnInit {

    title$: Observable<string>;

    @ViewChild('telInputBlockStudent') telInputBlock: ElementRef<HTMLInputElement>;
    @ViewChild('telInputBlockParent') telInputBlockParent: ElementRef<HTMLInputElement>;
    @ViewChildren('telInputBlock') intlTelInputs: QueryList<IntlTelInputComponent>;

    @ViewChild('telInputStudentElement') telInputStudentElement!: IntlTelInputComponent;
    @ViewChild('telInputParentElement') telInputParentElement!: IntlTelInputComponent;

    @ViewChildren(IonInput) ionInputs!: QueryList<IonInput>;


    enterPromoCode: boolean = false;
    acceptedRules = false;
    canSubmit = false;
    GENDER_FEMALE = GENDER_FEMALE;
    GENDER_MALE = GENDER_MALE;

    yearNow = Number(formatDate(new Date(), 'YYYY', 'en-EN'));
    _phone: string = '';

    phone$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    step1Register: boolean = true;
    step1RegisterDone: boolean = false;
    step2Test: boolean = false;
    step2TestDone: boolean = false;
    step3Group: boolean = false;
    step3GroupDone: boolean = false;
    showParentInfo: boolean = true;
    allowParentInfo: boolean | undefined = false;
    testUrl: string = '';
    days: number[] = [];
    months = MONTH_NAMES;
    years: number[] = [];
    showNoteNextClassMessage: boolean = false;
    utmData: [] = [];
    isItBeforeSchoolChild = false;
    isEnterNumberIsDeleted: boolean = false;
    promoCodeIsNotValid: boolean = false;
    promoCodeErrorMessage: string | undefined = undefined;

    protected readonly SCHOOL_CLASS = SCHOOL_CLASS;

    public studentPhone: string = '';
    parentPhone: string | null = null;
    refLink: string | null = null;

    gaClientID: string = '';
    gaSessionID: string = '';

    registerForm = this.fBuilder.group({
        studentFirstName: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(255), cyrillicCharactersValidator()]],
        studentLastName: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(255), cyrillicCharactersValidator()]],
        studentGender: ['', [Validators.required]],
        studentSchoolClass: ['', [Validators.required, Validators.max(13), Validators.min(1)]],
        birthdayItem: this.fBuilder.group({
            day: ['', [Validators.required, Validators.max(31), Validators.min(1)]],
            month: ['', [Validators.required, Validators.max(12), Validators.min(1)]],
            year: ['', [Validators.required, Validators.max(this.yearNow), Validators.min(1900)]],
        }),
        studentPhone: ['', [Validators.required, Validators.maxLength(255)]],
        parentEmail: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(255)]),
        parentPhone: new FormControl('', [Validators.required, Validators.maxLength(255)]),
        parentName: ['', [Validators.required, Validators.maxLength(255), cyrillicCharactersValidator()]],
        birthday: ['', []],
        agreement: [false, []],
        promocode: ['', [Validators.maxLength(20)]],
        utmData: [this.utmData, []],
        gaClientID: ['', []],
        gaSessionID: ['', []],
        gaPrice: ['6800', []],
    });

    constructor(
        private route: ActivatedRoute,
        private fBuilder: FormBuilder,
        private preloaderService: PreloaderService,
        public alertService: AlertService,
        public myGcService: MyGreenCountry,
        private authService: AuthService,
        public router: Router,
        private platform: Platform,
        private analyticService: AnalyticsService,
        public popoverController: PopoverController,
        private cookieService: CookieService,
        private translocoService: TranslocoService,
        private titleService: Title,
        private phoneUtils: PhoneUtilsService,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.title$ = this.translocoService.selectTranslate('route.registration');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });

        this.telInputBlock = {} as ElementRef<HTMLInputElement>;
        this.telInputBlockParent = {} as ElementRef<HTMLInputElement>;

        this.route.queryParams.subscribe({
            next: (params: any) => {
                this.phone = params.phone
                this.utmData = params.utmData;

                if (this.utmData !== null) {
                    // @ts-ignore
                    this.registerForm.controls['utmData'].setValue(this.utmData);
                }
            },
        });

        for (let i = FIRST_DAY_OF_MONTH; i <= LAST_DAT_OF_MONTH; i++) {
            this.days.push(i);
        }

        for (let i = this.yearNow - AGE_MIN_LIMIT; i >= YEAR_START; i--) {
            this.years.push(i);
        }

        this.showNextClassMessage();

        this.registerForm.valueChanges.subscribe(() => {
            this.checkValidity();
        });

        this.phone$.subscribe(value => {
            this.onPhoneChange(value);
        });
    }

    set phone(value: string) {
        this._phone = value;

        if (!this._phone) {
            let intlInputInstance = this.telInputStudentElement.intlTelInput;

            if (intlInputInstance) {
                let updatedPhone = this.phoneUtils.addCustomPhoneCode(intlInputInstance, this._phone);

                if (updatedPhone) {
                    this._phone = updatedPhone;
                }
            }
        }

        this.phone$.next(this._phone);
    }

    get phone(): string {
        return this._phone;
    }

    onPhoneChange(value: string): void {
        this.registerForm.controls['studentPhone'].setValue(value, {emitEvent: false});
    }

    checkValidity() {
        let form = this.registerForm;
        let birthdayItem = form.get('birthdayItem');

        this.allowParentInfo = form.get('studentFirstName')?.valid &&
            form.get('studentLastName')?.valid &&
            form.get('studentGender')?.valid &&
            form.get('studentSchoolClass')?.valid &&
            birthdayItem?.get('day')?.valid &&
            birthdayItem?.get('month')?.valid &&
            birthdayItem?.get('year')?.valid &&
            form.get('studentPhone')?.valid;

        if (this.allowParentInfo) {
            this.setTelTypeToParent()
        }

        let schoolClass = form.get('studentSchoolClass')?.value;

        if (schoolClass !== undefined && schoolClass !== null) {
            this.isItBeforeSchoolChild = Number(schoolClass) === BEFORE_SCHOOL_CHILD_CLASS;
        }
    }

    onPhoneInput(event: any) {
        let targetElement = event.target;

        if (targetElement.classList.contains('invalid-border-phone')) {
            targetElement.classList.remove('invalid-border-phone');
        }
    }

    setTelTypeToParent() {
        setTimeout(() => {
            (this.telInputBlockParent.nativeElement.querySelector('.register-form input[name=parentPhone]') as HTMLInputElement).type = 'tel'
        }, 350);
    }

    removeInvalidBorder(event: any) {
        let targetElement = event.target.parentElement.parentElement;
        let children = targetElement.querySelectorAll('ion-item');

        children.forEach((child: Element) => {
            if (child.classList.contains('invalid-border')) {
                child.classList.remove('invalid-border');
            }
        });
    }

    ngOnInit() {
        // let gaClient = this.cookieService.get('_ga');
        // this.gaClientID = gaClient ? gaClient.split('.').slice(2, 4).join('.') : '';
        this.gaSessionID = this.googleAnalyticsService.getSessionId() ?? '';

        // let gaSession = this.cookieService.get('_ga_VKZ2TF2G9C');
        // this.gaSessionID = gaSession ? gaSession.split('.')[2] : '';
        this.gaClientID = this.googleAnalyticsService.getClientId()?? '';
    }

    ngAfterViewInit() {
        setTimeout(() => {

            (this.telInputBlock.nativeElement.querySelector('.register-form input[name=studentPhone]') as HTMLInputElement).type = 'tel'

            if (this.phone != undefined) {
                // @ts-ignore
                let iti = window.intlTelInputGlobals.getInstance(document.querySelector('.register-form #studentPhone'));
                iti.setNumber(this.phone);
            }

        }, 350);

    }

    showNextClassMessage() {
        let now = new Date();
        let currentYear = now.getFullYear();
        let startDate = new Date(`${currentYear}-04-15`);
        let endDate = new Date(`${currentYear}-09-01`);

        if (now > startDate && now < endDate) {
            this.showNoteNextClassMessage = true;
        }
    }

    acceptRules() {
        this.acceptedRules = !this.acceptedRules;
        this.canSubmit = this.acceptedRules;
    }

    onSubmit(): void {
        this.updateFormValues();
        if (this.registerForm.valid) {
            this.doRegister(this.registerForm.value, true);
        } else {
            this.getFormValidationErrors();
        }
    }

    setStudentBirthday() {
        let month = this.registerForm.get('birthdayItem.month')
        if (!month?.valid) {
            this.addErrorBorder('month')
        }

        let year = this.registerForm.get('birthdayItem.year');
        if (!year?.valid) {
            this.addErrorBorder('year')
        }

        let day = this.registerForm.get('birthdayItem.day');
        if (!day?.valid) {
            this.addErrorBorder('day')
        }

        if (month?.value && year?.value && day?.value) {

            let birthday = year?.value + '-'
                + this.pad(month?.value) + '-'
                + this.pad(day?.value);

            this.registerForm.controls['birthday'].setValue(birthday);
        }
    }

    updateFormValues() {
        // this.registerForm.controls['studentPhone'].setValue(this.phone)
        let intlInputInstance = this.telInputParentElement.intlTelInput;

        if (!this.parentPhone && intlInputInstance) {
            this.parentPhone = this.phoneUtils.addCustomPhoneCode(intlInputInstance, this.parentPhone);
        }

        this.registerForm.controls['parentPhone'].setValue(this.parentPhone)

        this.setStudentBirthday()
        this.setGaData()

        this.registerForm.controls['agreement'].setValue(this.acceptedRules);
    }

    pad(d: any) {
        return (d < 10) ? '0' + d.toString() : d.toString();
    }

    setGaData() {
        this.registerForm.controls['gaClientID'].setValue(this.gaClientID);
        this.registerForm.controls['gaSessionID'].setValue(this.gaSessionID);
    }

    async doRegister(form: object, redirect: boolean = false, urlRedirect = '') {
        await this.preloaderService.showLoading("Зачекайте, будь ласка");
        this.authService
            .register(form)
            .subscribe({

                next: (data: RegisterApiResponse) => {

                    if (data.success) {
                        if (!this.platform.is('hybrid')) {
                            this.analyticService.registration(data.studentId.toString());
                        }

                        if (this.isItBeforeSchoolChild) {
                            this.router.navigate(['/home']);
                        } else {
                            this.step2Test = true;
                            this.step1RegisterDone = true
                            this.testUrl = data.urlTest

                            if (data.refLink) {
                                this.refLink = data.refLink;
                            }

                        }
                    } else {
                        if (!data.promoCodeValid) {
                            this.promoCodeIsNotValid = true;
                            this.promoCodeErrorMessage = data.error;
                        } else {
                            this.isEnterNumberIsDeleted = true;
                        }

                    }


                },

                error: (errorResponse: any) => {


                },

                complete: () => {

                    this.preloaderService.hideLoading();

                }

            })
    }


    async startTest() {
        this.myGcService.openUrl(this.testUrl, '_self')
    }


    removeErrorBorder(key: string) {
        let inputByName = document.querySelector(`ion-input[formControlName="${key}"]`);

        if (inputByName) {
            inputByName.classList.remove('invalid-border');
        }
    }

    addErrorBorder(key: string) {

        if (key === 'studentPhone' || key === 'parentPhone') {
            const studentPhoneInput = document.querySelector(`input[name="${key}"]`);

            if (studentPhoneInput) {
                studentPhoneInput.classList.add('invalid-border-phone');
            }

        } else if (key === 'studentSchoolClass' || key === 'month' || key === 'year' || key === 'day') {
            let itemById = document.querySelector(`ion-item[id="${key}"]`);

            if (itemById) {
                itemById.classList.add('invalid-border');
            }

        } else if (key === 'studentGender') {
            let inputByName = document.querySelectorAll('ion-item.gender');

            if (inputByName) {
                inputByName.forEach(item => {
                    item.classList.add('invalid-border');
                });
            }

        }
        let inputByName = document.querySelector(`ion-input[formControlName="${key}"]`);

        if (inputByName) {
            inputByName.classList.add('invalid-border');
        }
    }

    getFormValidationErrors() {
        let showMessage = true;

        Object.keys(this.registerForm.controls).forEach((key) => {
            // @ts-ignore
            let controlErrors: ValidationErrors = this.registerForm.get(key)?.errors;

            if (controlErrors != null) {
                this.addErrorBorder(key);
                Object.keys(controlErrors).forEach(keyError => {
                    if (showMessage) {
                        this.errorMessage(keyError);
                        showMessage = false;
                    }
                });
            }
        });
    }


    errorMessage(error: string) {

        let message = this.translocoService.translate('error.fields');

        switch (error) {
            case 'required':
                this.alertService.presentAlert(message, '', ['ok']);
                break;
            case 'pattern':
                this.alertService.presentAlert(message, '', ['ok']);
                break;
        }
    }

    async presentSharePopover(e: Event, isTestShare: boolean = false) {

        const popover = await this.popoverController.create({
            component: PopoverComponent,
            showBackdrop: false,
            size: "cover",
            side: "top",
            event: e,
            cssClass: `popover-class share-popover ${isTestShare ? 'test-link' : ''}`.trim(),
            alignment: "start",
            mode: "ios",
            arrow: true,
            componentProps: {
                isSharePopover: true,
                refUrl: isTestShare ? this.testUrl : this.refLink,
                isTestShare: isTestShare

            }
        });

        await popover.present();

        const {role} = await popover.onDidDismiss();

    }

    // getSelectedLanguageImage(): any {
    //     let selectedLang = LANGUAGES.find(lang => lang.value === this.activeLanguage);
    //
    //     if (selectedLang && selectedLang.image) {
    //         this.selectedLanguageIcon = selectedLang.image;
    //     }
    // }
    //
    // getLanguageImage(langValue: string): string {
    //     let selectedLang = LANGUAGES.find(language => language.value === langValue);
    //     return selectedLang ? selectedLang.image : LANGUAGES[0].image;
    // }
    //
    // getLanguageText(langValue: string): string {
    //     let selectedLang = LANGUAGES.find(language => language.value === langValue);
    //     return selectedLang ? selectedLang.text : LANGUAGES[0].text;
    // }
    //
    // changeLang(selectedLang: string) {
    //     this.translocoService.setActiveLang(selectedLang);
    //     this.localService.setLanguage(selectedLang);
    //     this.activeLanguage = selectedLang;
    //     this.getSelectedLanguageImage();
    // }
}
